module.exports = __webpack_public_path__ + "static/img/5.6ef871c4.png";